export { GovernancePage as default } from '@/components/pages/Ir/Governance'
